<template>
  <div>
    <!-- <div class="s-backtop">
      <transition name="el-fade-in">
        <div @click="backTop" :style="{'visibility': visible ? 'visible' : 'hidden'}" class="back_top0 back_top1"></div>
      </transition>
      <div @click="ideaFn" class="back_top0 s_idea"></div>
    </div> -->
    <!-- <div class = 'posiBox'>
      <a class = 'itembox' @click="ideaFn">
        <img class = 'itemImg' src="../../../static/images/yjfk.svg" alt="">
        <a  class="louti">意见反馈</a>
      </a>
    </div> -->

    <el-dialog class="yijianDialog" title="意见反馈" :close-on-click-modal='false' :visible.sync="showIdea" width="780px" :before-close="clearFn">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item class="fankui" label="姓名：" prop="personName">
          <el-input v-model="ruleForm.personName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item class="fankui" label="电话：" prop="tel">
          <el-input v-model="ruleForm.tel" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item class="fankui" label="单位：" prop="entpName">
          <el-input v-model="ruleForm.entpName" placeholder="请输入单位"></el-input>
        </el-form-item>
        <el-form-item class="fankui" label="邮箱：" prop="email" 
        :rules="[
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
          ]"
    >
          <el-input  v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item class="fankui" label="反馈内容：" prop="retroaCont">
          <el-input type="textarea" 
          :rows="6" 
          maxlength="2000"
          show-word-limit 
          v-model="ruleForm.retroaCont" 
          placeholder="您有什么建议吗？请告诉我们..."></el-input>
        </el-form-item>
        <el-form-item label="相关图片：">
          <up-img v-if="showIdea" class="xiangguan_img" toggleClass=".xiangguan_img" :ruleImgList="ruleImgList" :imgMaxLength="imgMaxLength"></up-img>
          <ul class="clearfix">
            <li class="fl">
              <div style="font-size: 13px;color: rgb(153, 153, 153);"> <i class="el-icon-info"></i>上传jpg/png格式文件，大小不超过1MB</div>
            </li>
            <li v-show="ruleImgList.length>0" class="fr" style="padding-right: 20px;">
              <div>共<span class="counts">3</span>张，还能上传<span class="counts">{{3-(ruleImgList.length)}}</span>张</div>
            </li>
          </ul>
        </el-form-item>
      </el-form>
    
        <div slot="footer" class="dialog-footer">
          <el-button @click="clearFn">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </div>
       
      
    </el-dialog>
  </div>
</template>

<script>
import { getCookie } from '../../../static/js/cookie.js'
import upImg from '../imgUpload1/index.vue'
export default {
  props: ['showIdea'],
  components:{
    upImg
  },
  data(){
    return {
      isClick: false,
      visible: false,
      // showIdea: false,
      imgMaxLength: 3,
      ruleImgList: [],
      ruleForm: {
        retroaCont: '',
        email:'',
        personName:'',
        tel:'',
        entpName:''
      },
      rules: {
        retroaCont: [
          { required: true, message: '请输入反馈内容', trigger: 'blur' }
        ],
      },
    }
  },
  mounted() {
    
  },
  methods: {

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.Axios({
              url: Action.UNLOGIN_INSERT,
              method: "post",
              data: {
                sourceType :'1',
                email:this.ruleForm.email,
                personName:this.ruleForm.personName,
                tel:this.ruleForm.tel,
                entpName:this.ruleForm.entpName,
                retroaCont: this.ruleForm.retroaCont,
                opinRetroaPicList: this.ruleImgList
              }
            }).then(res => {
              res = res.data;
              if (res.code == "000") {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                })
                this.isClick = false;
                // this.$emit('closefankui', false)
                // this.ruleForm.retroaCont = '' 
                // this.ruleForm.email = '' 
                // this.ruleForm.personName = '' 
                // this.ruleForm.tel = '' 
                // this.ruleForm.entpName = '' 
                // this.ruleImgList = [];
                this.clearFn()
              } else {
                this.$alert(res.msg || "系统错误...", "错误提示", {
                  cofirmButtonText: "确定",
                  type: "error"
                });
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    clearFn(){
      this.ruleForm.retroaCont = '' 
      this.ruleForm.email = '' 
      this.ruleForm.personName = '' 
      this.ruleForm.tel = '' 
      this.ruleForm.entpName = '' 
      this.ruleForm.contents = '';
      this.ruleImgList = [];
      this.isClick = false;
      this.$emit('closefankui', false)
    },
  },
};
</script>

<style lang = 'less' >
  .el-dialog__header{
    background:#409EFF!important;
    padding: 10px 20px 10px;
  }
  .el-dialog__title{
    color:#fff!important;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color:#fff!important;
}
  .el-dialog__headerbtn {
    position: absolute;
    top: 13px;
    right: 20px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
    color:#fff!important;
  }
  .posiBox{
    width: 76px;
	  background-color: #f2f5fa;
    box-shadow: 0px 2px 8px 0px 
      #efefef;
    border-radius: 5px;
    position:fixed;
    right:10px;
    top:800px;
    z-index:600;
    box-sizing: border-box;
    box-sizing: border-box;
    .itembox{
      width:76px;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      cursor: pointer;
      .itemImg{
        width: 44px;
	      height: 44px;
        margin:10px 0;
      }
      .louti{
        width: 56px;
        line-height: 20px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #222222;
        text-align: center;
        // margin-top:5px;
      }
    
    .itembox:hover .louti{
      color: #2c6eff;
    }
    
    .louti:hover{
      color: #2c6eff;
    }
  }
    }



</style>



// WEBPACK FOOTER //
// src/components/backtop/index.vue